module.exports = __webpack_public_path__ + "static/media/HS5116HJ.a279c7d9.jpg";